export type Locale = 'en' | 'ru'

const translations = {
  en: {
    // Settings
    'settings.title': 'Settings',
    'settings.profile': 'Profile',
    'settings.privacy': 'Privacy',
    'settings.notifications': 'Notifications',
    'settings.appearance': 'Appearance',
    'settings.language': 'Language',
    'settings.logout': 'Log out',
    'settings.save': 'Save',
    'settings.saved': 'Saved',
    'settings.firstName': 'First name',
    'settings.lastName': 'Last name',
    'settings.username': 'Username',
    'settings.bio': 'Bio',
    'settings.phone': 'Phone',
    'settings.theme': 'Theme',
    'settings.darkMode': 'Dark mode',
    'settings.lightMode': 'Light mode',
    'settings.fontSize': 'Font size',
    'settings.accentColor': 'Accent color',
    'settings.soundEnabled': 'Notification sounds',
    'settings.emojiStatus': 'Emoji status',
    'settings.chatWallpaper': 'Chat wallpaper',
    // Navigation
    'nav.chats': 'Chats',
    'nav.contacts': 'Contacts',
    'nav.settings': 'Settings',
    'nav.newChat': 'New chat',
    'nav.newGroup': 'New group',
    'nav.newChannel': 'New channel',
    'nav.savedMessages': 'Saved Messages',
    // Chat
    'chat.typeMessage': 'Write a message…',
    'chat.reply': 'Reply',
    'chat.edit': 'Edit',
    'chat.delete': 'Delete',
    'chat.forward': 'Forward',
    'chat.copy': 'Copy text',
    'chat.translate': 'Translate',
    'chat.pin': 'Pin',
    'chat.unpin': 'Unpin',
    'chat.messageDeleted': 'Message deleted',
    'chat.messageEdited': 'edited',
    'chat.sending': 'Sending…',
    'chat.typing': 'typing…',
    'chat.online': 'online',
    'chat.today': 'Today',
    'chat.yesterday': 'Yesterday',
    'chat.noMessages': 'No messages yet',
    'chat.attach': 'Attach file',
    'chat.location': 'Send location',
    'chat.contact': 'Send contact',
    'chat.schedule': 'Schedule',
    // Search
    'search.placeholder': 'Search',
    'search.noResults': 'No results',
    'search.chats': 'Chats',
    'search.messages': 'Messages',
    // Groups
    'group.members': 'Members',
    'group.admin': 'Admin',
    'group.kick': 'Kick',
    'group.addMember': 'Add member',
    'group.inviteLink': 'Invite link',
    'group.slowMode': 'Slow mode',
    'group.noSlowMode': 'Off',
    // Channel
    'channel.subscribe': 'Subscribe',
    'channel.subscribed': 'Subscribed',
    'channel.posts': 'Posts',
    'channel.stats': 'Statistics',
    'channel.settings': 'Settings',
    'channel.publish': 'Publish',
    'channel.publishing': 'Publishing…',
    'channel.writePost': 'Write a post…',
    // Privacy
    'privacy.title': 'Privacy',
    'privacy.whoCanSee': 'Who can see',
    'privacy.phoneNumber': 'Phone number',
    'privacy.profilePhoto': 'Profile photo',
    'privacy.lastSeen': 'Last seen',
    'privacy.whoCanAddToGroups': 'Add to groups',
    'privacy.whoCanMessage': 'Send messages',
    'privacy.activeSessions': 'Active Sessions',
    'privacy.terminateAll': 'Terminate all others',
    'privacy.currentSession': 'current',
    'privacy.twoFactor': 'Two-Factor Authentication',
    'privacy.security': 'Security',
    'privacy.everyone': 'Everyone',
    'privacy.contacts': 'Contacts',
    'privacy.nobody': 'Nobody',
    // Status
    'status.online': 'online',
    'status.offline': 'offline',
    // Misc
    'misc.cancel': 'Cancel',
    'misc.confirm': 'Confirm',
    'misc.done': 'Done',
    'misc.back': 'Back',
    'misc.close': 'Close',
    'misc.loading': 'Loading…',
    'misc.error': 'Error',
    'misc.retry': 'Retry',
    'misc.copy': 'Copy',
    'misc.copied': 'Copied',
    'misc.send': 'Send',
    'misc.media': 'Media',
    'misc.files': 'Files',
    'misc.links': 'Links',
    'misc.noFiles': 'No files yet',
    'misc.noLinks': 'No links yet',
  },
  ru: {
    // Настройки
    'settings.title': 'Настройки',
    'settings.profile': 'Профиль',
    'settings.privacy': 'Конфиденциальность',
    'settings.notifications': 'Уведомления',
    'settings.appearance': 'Оформление',
    'settings.language': 'Язык',
    'settings.logout': 'Выйти',
    'settings.save': 'Сохранить',
    'settings.saved': 'Сохранено',
    'settings.firstName': 'Имя',
    'settings.lastName': 'Фамилия',
    'settings.username': 'Имя пользователя',
    'settings.bio': 'О себе',
    'settings.phone': 'Телефон',
    'settings.theme': 'Тема',
    'settings.darkMode': 'Тёмная тема',
    'settings.lightMode': 'Светлая тема',
    'settings.fontSize': 'Размер шрифта',
    'settings.accentColor': 'Цвет акцента',
    'settings.soundEnabled': 'Звук уведомлений',
    'settings.emojiStatus': 'Emoji-статус',
    'settings.chatWallpaper': 'Обои чата',
    // Навигация
    'nav.chats': 'Чаты',
    'nav.contacts': 'Контакты',
    'nav.settings': 'Настройки',
    'nav.newChat': 'Новый чат',
    'nav.newGroup': 'Новая группа',
    'nav.newChannel': 'Новый канал',
    'nav.savedMessages': 'Избранное',
    // Чат
    'chat.typeMessage': 'Сообщение…',
    'chat.reply': 'Ответить',
    'chat.edit': 'Редактировать',
    'chat.delete': 'Удалить',
    'chat.forward': 'Переслать',
    'chat.copy': 'Копировать текст',
    'chat.translate': 'Перевести',
    'chat.pin': 'Закрепить',
    'chat.unpin': 'Открепить',
    'chat.messageDeleted': 'Сообщение удалено',
    'chat.messageEdited': 'изменено',
    'chat.sending': 'Отправка…',
    'chat.typing': 'печатает…',
    'chat.online': 'в сети',
    'chat.today': 'Сегодня',
    'chat.yesterday': 'Вчера',
    'chat.noMessages': 'Нет сообщений',
    'chat.attach': 'Прикрепить файл',
    'chat.location': 'Отправить геолокацию',
    'chat.contact': 'Отправить контакт',
    'chat.schedule': 'Запланировать',
    // Поиск
    'search.placeholder': 'Поиск',
    'search.noResults': 'Ничего не найдено',
    'search.chats': 'Чаты',
    'search.messages': 'Сообщения',
    // Группы
    'group.members': 'Участники',
    'group.admin': 'Администратор',
    'group.kick': 'Исключить',
    'group.addMember': 'Добавить участника',
    'group.inviteLink': 'Пригласительная ссылка',
    'group.slowMode': 'Медленный режим',
    'group.noSlowMode': 'Выкл',
    // Канал
    'channel.subscribe': 'Подписаться',
    'channel.subscribed': 'Вы подписаны',
    'channel.posts': 'Посты',
    'channel.stats': 'Статистика',
    'channel.settings': 'Настройки',
    'channel.publish': 'Опубликовать',
    'channel.publishing': 'Публикуем…',
    'channel.writePost': 'Написать пост…',
    // Конфиденциальность
    'privacy.title': 'Конфиденциальность',
    'privacy.whoCanSee': 'Кто видит',
    'privacy.phoneNumber': 'Номер телефона',
    'privacy.profilePhoto': 'Фото профиля',
    'privacy.lastSeen': 'Когда был(-а) в сети',
    'privacy.whoCanAddToGroups': 'Добавление в группы',
    'privacy.whoCanMessage': 'Отправка сообщений',
    'privacy.activeSessions': 'Активные сессии',
    'privacy.terminateAll': 'Завершить все остальные',
    'privacy.currentSession': 'текущая',
    'privacy.twoFactor': 'Двухфакторная аутентификация',
    'privacy.security': 'Безопасность',
    'privacy.everyone': 'Все',
    'privacy.contacts': 'Контакты',
    'privacy.nobody': 'Никто',
    // Статус
    'status.online': 'в сети',
    'status.offline': 'не в сети',
    // Прочее
    'misc.cancel': 'Отмена',
    'misc.confirm': 'Подтвердить',
    'misc.done': 'Готово',
    'misc.back': 'Назад',
    'misc.close': 'Закрыть',
    'misc.loading': 'Загрузка…',
    'misc.error': 'Ошибка',
    'misc.retry': 'Повторить',
    'misc.copy': 'Копировать',
    'misc.copied': 'Скопировано',
    'misc.send': 'Отправить',
    'misc.media': 'Медиа',
    'misc.files': 'Файлы',
    'misc.links': 'Ссылки',
    'misc.noFiles': 'Файлов нет',
    'misc.noLinks': 'Ссылок нет',
  },
} as const

type TranslationKey = keyof typeof translations.en

export function t(locale: Locale, key: TranslationKey, fallback?: string): string {
  return (translations[locale] as Record<string, string>)[key]
    ?? (translations.en as Record<string, string>)[key]
    ?? fallback
    ?? key
}
